// src/pages/Home.js
import React, { useEffect, useRef, useState } from "react";
import "./home.css";
import bottle from "../assets/bottle.png";   // slider image
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Home() {

  const textRef = useRef(null);

  useEffect(() => {
    const element = textRef.current;
    if (!element) return;

    const str = element.textContent;
    element.textContent = "";

    [...str].forEach((letter, i) => {
      let span = document.createElement("span");
      span.textContent = letter;
      span.style.animationDelay = `${i * 0.15}s`;
      element.appendChild(span);
    });
  }, []);

  /* ------------------ BOTTLE SLIDER ------------------ */
  const [currentBottle, setCurrentBottle] = useState(bottle);

  const bottleImages = [
    bottle,  // If you add more: bottle2, bottle3
  ];

  useEffect(() => {
    let index = 0;

    const interval = setInterval(() => {
      index = (index + 1) % bottleImages.length;
      setCurrentBottle(bottleImages[index]);
    }, 2600);

    return () => clearInterval(interval);
  }, []);

  /* --------------------------------------------------- */

  return (
    <div className="home-root">

      {/* HERO SECTION */}
      <section className="hero shadow">

        {/* LEFT SIDE - BOTTLE CARD */}
        <div className="hero-left">
          <div className="bottle-card shadow">
            <img src={bottle} alt="HilalUp bottle" className="bottle-img" />
          </div>

          {/* Launch Slider */}
          <div className="launch-slider bottle-launch">
            <div className="launch-track">
              <span>Launching Soon</span>
              <span>Launching Soon</span>
              <span>Launching Soon</span>
              <span>Launching Soon</span>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="twos">
        <div className="hero-right">
          <img src={logo} alt="logo" className="imgloo"/>
          <h1 className="pop-text" ref={textRef}>HilalUp</h1>
        </div>
          <div className="bt">
            <Link to="/book" className="buttonn"><span className="s">Contact Us</span></Link>
          </div>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <div className="about-root">

        <h1 className="about-title">About HilalUp</h1>

        <p className="about-text1">
          HilalUp is India’s homegrown refreshing drink crafted with purity, taste,
          and trust. We believe in beverages that not only taste great but are
          made with the right intention— <strong>“Taste bhi halal, niyat bhi nek.”</strong>
        </p>

        <h2 className="section-heading">Current Available Flavour</h2>

        <div className="flavour-card">
          <h3>🍃 Jeera (Zesty Jeera Masala)</h3>
          <p>Our first launch — a perfect blend of bold jeera, Indian spices, and natural refreshment.</p>
        </div>

        <h2 className="section-heading">New Flavours Coming Soon!</h2>

        <ul className="coming-list">
          <li>🍋 Lemon Masala</li>
          <li>🥤 Cola Classic</li>
          <li>🍊 Orange Pop</li>
          <li>🥭 Mango Splash</li>
          <li>✨ And many more…</li>
        </ul>

        <p className="about-text">
          Every new flavour is being crafted with care — keeping purity and Indian tradition at the heart of HilalUp.
        </p>
      </div>

      {/* ----------------- CONTACT SECTION ----------------- */}
      <div className="contact-root">

       {/* 3D ROTATING BOTTLE INSIDE CONTACT SECTION */}
<div className="contact-bottle-slider">
  <img
    src={currentBottle}
    className="contact-bottle-img rotate-bounce-3d"
    alt="HilalUp Bottle Rotating"
  />
</div>



        <div className="contact-card">

          <div className="contact-left">
            <div className="contact-details">
              <p className="contact-line">
                📧 <a href="mailto:hilalupofficial@gmail.com">hilalupofficial@gmail.com</a>
              </p>
              <p className="contact-line">
                📞 <a href="c">+91 9329766366</a>
              </p>
            </div>

            <div className="hours">
              <p><strong>Customer Support</strong></p>
              <p>Mon - Sat: 9:00 AM - 6:00 PM</p>
            </div>
          </div>

        </div>
      </div>

      {/* FOOTER */}
      <footer className="footer">
        <p className="footer-title">Connect With Us</p>

        <div className="footer-links">
          <a href="https://instagram.com/hilalup_india" target="_blank" rel="noopener noreferrer" className="footer-btn">📸 Instagram</a>
          <a href="mailto:hilalupofficial@gmail.com" className="footer-btn">✉️ Gmail</a>
        </div>

        <p className="copy">© 2025 HilalUp. All Rights Reserved.</p>
      </footer>

    </div>
  );
}
